export default __webpack_public_path__ + "assets/images/9306e31e868593d34ce9b8500c878e47.png";